import { Box, Typography } from "@mui/material";

import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

export default function BoxTransferHistory({ transferHistoryItem }) {

  const isEnter = transferHistoryItem?.typeId === 11;
  const isExit = transferHistoryItem?.typeId === 14;

  const typeColor = isEnter ? "success.main" : isExit ? "error.main" : "text.main";
  const TypeIcon = isEnter ? LoginIcon : isExit ? LogoutIcon : null;

  return (
    <Card marginBottom={15}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
        pb={2}
      >
        <Box display="flex" alignItems="center" flexDirection="row-reverse">
          <img
            src={DefaultUrlWeb + transferHistoryItem?.coinImageUrl}
            alt=""
            width={25}
          />
          <Typography variant="h5" color="text.main" pl={1}>
            {transferHistoryItem?.coinName}
          </Typography>
        </Box>

        <Box>
          {" "}
          <Typography variant="subtitle1" color="text.secondary">
            {transferHistoryItem?.date} {transferHistoryItem?.time}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="row-reverse" pb={2}>
        <Typography variant="h6" color="text.secondary">
          Amount
        </Typography>

        <Typography variant="h6" px={1}>
          {transferHistoryItem?.amount}
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row-reverse">
        <Typography variant="h6" color="text.secondary">
          type
        </Typography>

        <Box display={"flex"} alignItems={"center"}>
          {TypeIcon && <TypeIcon fontSize="small" color={isEnter ? 'success' : isExit ? 'error' : 'inherit'} sx={{ transform: isEnter ? "rotate(180deg)" : "unset" }} />}

          <Typography variant="h6" px={1} color={typeColor}>
            {transferHistoryItem?.type}
          </Typography>

        </Box>
      </Box>
    </Card>
  );
}
